import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface CrownIconProps {
  size?: number
  color?: string
  className?: string
  title?: string
}

/**
 * Crown — the "Elite" skill level, the top of the ramp. Mirrors the mobile
 * Player Finder's MaterialCommunityIcons `crown` glyph so both platforms read
 * the same.
 */
const CrownIcon: React.FC<CrownIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  className,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M5 20h14v-2H5v2Zm0-4h14l1.7-8.5-4.45 3.05L12 4l-4.25 6.55L3.3 7.5L5 16Z'
        fill={color}
      />
    </svg>
  )
}

export default CrownIcon
